import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function InvalidCommodity() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "invalid_commodity" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="file-text" size={40} color="#fcba03" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>
              {modal.data.descriptionTop}
            </div>
            <br />
            <div className={styles.description}>
              <span>{modal.data.details}</span>
            </div>
            <br />
            <div className={styles.description}>
              Please see the Quote for other lines of coverage and contact us at{" "}
              <span>hello@coverbadger.com</span> if you have any questions
            </div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.cancel} onClick={() => setModal("")}>
                  {modal.data.buttonLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
